import { render, staticRenderFns } from "./BankCode.vue?vue&type=template&id=2b947453&"
import script from "./BankCode.vue?vue&type=script&lang=js&"
export * from "./BankCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports